export default {
  // 단어
  'profile': 'Account',
  'user': 'User',
  'login': 'Login',
  'logout': 'Logout',
  'ID': 'ID',
  'ID_email': 'ID (email format)',
  'PW': 'Password',
  'PW_desc': 'Enter 8-12 characters: letters, special characters, and numbers.',
  'PW_confirm': 'Confirm Password',
  'PW_confirm_desc': 'Confirm your password',
  'agreement_view_text': 'Open',
  'required_label': 'Required',
  'PW_origin': 'Current Password',
  'PW_new': 'New Password',
  'PW_new_confirm': 'Confirm New Password',
  'check_email_message':'Please check your email',
  'check_email_desc':'Please click the verification button in your email',
  'footer':'Copyright 2025. KOINO Inc. All rights reserved.',
  'SC0010': 'Credit',
  'SC0030': 'Bank Transfer',
  'SC0060': 'Mobile Billing',
  'Superadmin': 'Service',
  'Corporate': 'Corporate',
  'LMM100': 'LMM100',
  'LMM300': 'LMM300',
  'LMM500': 'LMM500',
  'LMM1000': 'LMM1000+',
  'LMM1000+': 'LMM1000+',
  'Basic': 'Basic',
  'Free': 'Free Trial',
  'Email': 'Email',
  'name': 'Name',
  'phone': 'Phone Number',
  'office_phone': 'Office Phone',
  'subscription_path': 'Subscription Path',
  'windows': 'Windows',
  'Windows': 'Windows',
  'linux': 'Linux',
  'mac': 'Mac',
  'android': 'Android',
  'agent': 'Agent',
  'remote_device': 'Remote Device',
  'download': 'Download',
  'manual': 'Manual',
  'service': 'Service',
  'payment': 'Payment',
  'manage': 'Manage',
  'manager': 'Manager',
  'group': 'Group',
  'group_info': 'Group Info',
  'multiple': 'Multiple',
  'information': 'Information',
  'threshold': 'Alert Threshold',
  'limit': 'Limit',
  'alert': 'Alert',
  'normal': 'Normal',
  'setting': 'Setting',
  'device': 'Remote Device',
  'type': 'Type',
  'add': 'Add',
  'add_n': 'Add {v}',
  'remove': 'Remove',
  'delete': 'Delete',
  'progress': 'Progress',
  'time': 'Time',
  'hour': 'Hour',
  'minute': 'Minute',
  'second': 'Second',
  'device-in-group': 'Devices in Group',
  'list-of': 'List of {v}',
  'total': 'Total',
  'history': 'History',
  'registration': 'Registration',
  'statistics': 'Statistics',
  'stats': 'Stats',
  'update': 'Update',
  'renew': 'Renew',
  'connected': 'Connected',
  'disconnected': 'Disconnected',
  'running': 'Running',
  'sub-manager': 'Sub-manager',
  'execute': 'Execute',
  'cancel': 'Cancel',
  'ea': 'EA',
  'WON': 'WON',
  'months': 'Months',
  'years': 'Years',
  'back': 'Back',
  'expire': 'Expire',
  'notify': 'Notify',
  'help': 'Help',
  'status': 'Status',
  'program': 'Program',
  'homepage': 'Homepage',
  'web': 'Web',
  'proposal': 'Proposal',
  'brochure': 'Brochure',
  'ios': 'iOS',
  'etc': 'Etc',
  'on-work': 'In Progress',
  'list-view': 'List',
  'card-view': 'Icon',
  'live-view': 'Thumbnail',
  'delete-n': 'Delete {v}',
  'move-group-n': 'Move Group',
  'selected': 'Selected',
  'accessable': 'Accessible',
  'empty': 'Empty',
  'device_limit': 'Maximum Remote Device Registration Limit',
  'device_name': 'Remote Device Name',
  'device_name_identical': 'Duplicate Remote Device Name.',
  'device_name_edit': 'Edit Remote Device Name',
  'device_name_desc': 'Change the remote device name from <b>{alias}</b> to the following:<br><br>[Enter the new remote device name]',
  'device_name_confirm': 'The remote device name will be changed from <b>{alias}</b> to <b>{value}</b>.',
  // MDM device policy (configuration) apply
  'mdm_config': 'Configuration',
  'mdm_config_unassigned': 'Unassigned',
  'mdm_apply_config': 'Change Configuration',
  'device_location_map': 'View Remote Device Location',
  'map_search_placeholder': 'Search device',
  'map_select_all': 'Select all',
  'map_shown_count': '{count} shown',
  'map_empty': 'No online devices with reported location.',
  'mdm_change_config': 'Change Configuration',
  'mdm_apply_config_desc': 'Select a configuration to apply to the selected devices. It applies only to devices matching the configuration OS.',
  'mdm_apply_config_placeholder': 'Select configuration',
  'mdm_apply_summary': 'Apply {apply} · Skip {skip}',
  'mdm_apply_skip_reason': 'Already same {same} · OS mismatch {os}',
  'mdm_apply_target': 'Target devices',
  'mdm_apply_target_count': '{count} devices',
  'mdm_config_current_applied': '(currently applied)',
  'mdm_os_unsupported': 'Unsupported',
  'mdm_apply_none': 'No devices can receive the selected configuration.',
  'mdm_apply_done': 'Configuration applied ({success})',
  'mdm_apply_done_excluded': 'Configuration applied ({success} applied · {excluded} skipped)',
  'mdm_status_applied': 'Applied',
  'mdm_status_pending': 'Pending',
  'mdm_status_failed': 'Failed',
  'O/S': 'O/S',
  'edit': 'Edit',
  'refresh': 'Refresh',
  'off-editmode': 'Exit Edit Mode',
  'emptied_memo': '-',
  'upper_group': 'Upper Group',
  'all_device': 'All Devices',
  'submit': 'Submit',
  'create': 'Create',
  'delete_group': 'Delete Group',
  'delete_device': 'Delete Remote Device',
  'device_logoff': 'Log Off Remote Device',
  'favorate': 'Favorite',
  'search': 'Search',
  'by_user': '{v} by User',
  'by_device': '{v} by Remote Device',
  'by_type': '{v} by Type',
  'by_daily': 'Daily',
  'by_monthly': 'Monthly',
  'alert_count': 'Alert Count',
  'use_rate': 'Usage Rate',
  'rate': 'Rate',
  'use_count': 'Usage Count',
  'select_date': 'Select Period',
  'connect_count_of_remote': 'Trend of Remote Access Attempts',
  'count_of_alert': 'Trend of Alert Count',
  'chart': 'Chart',
  'date': 'Date',
  'host': 'Host',
  'viewer': 'Viewer',
  'at_time': 'Time',
  'start_time': 'Start Time',
  'end_time': 'End Time',
  'start_date': 'Start Date',
  'expire_date': 'Expire Date',
  'event_time': 'Event Time',
  'login_time': 'Login Time',
  'delete_time': 'Delete Time',
  'payment_date': 'Payment Date',
  'type_of_device': 'Type of Remote Device',
  'alert_message': 'Alert Message',
  'browser': 'Browser',
  'file_name': 'File Name',
  'size': 'Size',
  'top10': 'Top 10',
  'change': 'Change',
  'do_change': 'Make Change',
  'advenced_auth': '2-Step Verification (OTP)',
  'department': 'Department',
  'cowork_position': 'Position',
  'timezone': 'Timezone',
  'date_format': '@:date Format',
  'time_sec': 'Time (sec)',
  'auto_update': 'Auto Update',
  'active': 'Active',
  'inactive': 'Inactive',
  'permission': 'Permission',
  'target': 'Target',
  'common': 'Common',
  'web_manager': 'Web Manager',
  'CS_manager': 'CS Manager',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': 'License',
  'regist_service': 'Add @:license',
  'update_service': 'Renew @:service',
  'device_type': 'Device Type',
  'device_vol': 'Number of Devices',
  'exceed_device_vol': 'Exceeded Remote Devices',
  'remain': 'Remaining Period',
  'period': 'Period',
  'price': 'Price',
  'total_price': 'Total Price',
  'payment_type': 'Payment Type',
  'payment_method': 'Payment Method',
  'remark': 'Remark',
  'notice': 'Notice',
  'cs_center': 'Customer Center',
  'cs_phone': '02-6949-0488, 070-7126-8663',
  'save': 'Save',
  'find_n': 'Find {v}',
  'check_n': 'Check {v}',
  'signup': 'Sign Up',
  'trial': 'Try Free',
  'use_for': 'Subscription Type',
  'personal': 'Personal',
  'enterprise': 'Enterprise',
  'company': 'Company',
  'continue': 'Continue',
  'temperature': 'Temperature',
  'speed': 'Speed',
  'running_time': 'Running Time',
  'system_time': 'System Time',
  'version': 'Version',
  'access_log': 'Access/Control History',
  'list_of_process': 'Process List',
  'list_of_hardware': 'Hardware List',
  'list_of_software': 'Software List',
  'enter_n': 'Enter {v}',
  'reset_n': 'Reset {v}',
  'authorization': 'Authentication',
  'send_n': 'Send {v}',
  'resend_n': 'Resend {v}',
  'close': 'Close',
  'secure': 'Secure',
  'available_count': 'Available Devices',
  'submanager-right': 'Sub-manager Rights',
  'access-registration-history': 'Remote Control Access Request History',
  'access-num': 'Serial Number',
  'device-name': 'Remote Device Name',
  'device-ip': 'Remote Device IP',
  'application-date': 'Application Date',
  'application-period': 'Application Period',
  'approver': 'Approver',
  'applicant': 'Applicant',
  'approval-status': 'Approval Status',
  'approval': 'Approval',
  'approval-ing': 'In Progress',
  'function-settings': 'Policy Mgmt',
  'function-settings01': 'Account Lock Attempts (count)',
  'function-settings02': 'Remote Access Idle Time (min)',
  'function-settings03': 'File Transfer',
  'blocking-settings': 'IP Access Mgmt',
  'blocking-settings01': 'Block/Allow Policy',
  'approval-submit-user': 'Reapply',
  'blocking-super-settings': 'Policy Usage',
  'reset-pw': 'Reset',
  'reject-submit': 'Reject',
  'reject': 'Deny',
  'security-access': 'Agree',
  'manager-id': 'Manager',
  'sub-manager-id': 'Sub-manager',
  'reject-access': 'Cancel Approval',
  'request-agent': 'Remote Device',
  'request-date': 'Request Period',
  'request-reason': 'Reason',
  'approval-reason': 'Department Head\'s Opinion',
  'security-access-title': 'Agreement on Security Pledge',
  'excel-form': 'Download Excel Template',
  'approval-apply': 'Apply Approval Process',
  'user-in-group': 'Users with Group Access',
  'deleted-device-edit': 'Edit',
  'request-history': 'Access Request History',
  'approval-process': 'Access Request Approval',
  'approval-process-history': 'Access Request Approval History',
  'major-os-version': 'Major OS Version',
  'minor-os-version': 'Minor OS Version',
  'session-time': 'Remote Access Retention Time (min)',
  'account_security': 'Account Security',
  'password_level': 'Password Complexity Settings',
  'password_level0': 'No Restriction (4 to 12 characters)',
  'password_level1': 'Enter letters + numbers within 6 to 12 characters.',
  'password_level2': 'Enter letters + numbers + special characters within 8 to 12 characters.',
  'password_level3': 'Enter uppercase letters + lowercase letters + numbers + special characters within 8 to 12 characters.',
  'self_unlock': 'Allow Self-unlocking for Locked Accounts',
  'vaccine': 'Process/Service Detection',
  'capture': 'Screen Capture and Recording',
  'display-power-save': 'Prevent Display Power Save',
  'system-power-save': 'Prevent System Power Save',
  'security-agreement': 'Use Security Agreement',
  'remote-policy': 'Remote Function Policy',
  'user-connection-policy': 'User Connection Environment Policy',
  'os-version': 'Allowed Windows OS Versions',
  'blocking-settings-ip-list': 'IP Access List',
  'single-ip': 'Single IP Address',
  'reason': 'Reason',
  'range-ip-start': 'Start Address',
  'range-ip-end': 'End Address',
  'subnet-ip': 'Subnet Address',
  'time-added': 'Applied Time',
  'ip-address': 'IP Address',
  'password-expired': 'Password Maximum Usage Period (days)',
  'excel-users': 'Bulk User Registration',
  'enrollment': 'Registration',
  'excel-groups': 'Bulk Group Registration',
  'account-manage': 'User',
  'all-devices': 'Devices',
  'tutorial': 'Tutorial',
  'device-drop-all': 'All PCs',
  'service-payment-history': 'Service Payment History',
  'tutorial-device': 'New to this? (Learn how to add remote PCs)',
  'tutorial-group': 'Need help with group management? (Learn about group management features)',
  'tutorial-manager': 'What is a user account? (Learn about account management features)',
  'tutorial-statistics': 'What features are provided in statistics/history? (Learn about statistics/history features)',
  'tutorial-top10': 'Need help with group management? (Learn about group management features)',
  'tutorial-download': 'Guide for downloading and installing remote devices',
  'tutorial-license': 'Having issues with electronic payments?',
  'first-add-device': 'Add Remote PCs',
  'download_remote_device': 'Agent Installation',
  
  // 메세지
  'no-selects': 'No items selected.',
  'no-content': 'No matching items available.',
  'no-agent': 'No registered remote devices. Please add remote PCs.',
  'on_working': 'Under preparation.',
  'has_new_message': 'You have a new notification.',
  'not_save_warning': 'Unsaved changes will not be applied. Do you wish to proceed?',
  'not_online_warning': 'The remote device is not online.',
  'no_input_data': 'No input provided.',
  'add_child_group': 'Add a subgroup under "{name}".<br>Please enter the group name.',
  'add_root_group': 'Add a group to the "root".<br>Please enter the group name.',
  'duplication_group_name': 'A group with the same name already exists in this location.',
  'created_group': 'Group has been created.',
  'please_select_group': 'Please select a group.',
  'identical_group': 'You attempted to move to the same remote device group. Please select a different remote device group.',
  'confirm_delete_group': 'When a group is deleted, devices in that group will be moved to the default group.<br>Do you wish to delete?',
  'deleted_group': 'The group has been deleted.',
  'all_device_has_no_child': 'The \'All Devices\' group cannot contain subgroups.',
  'confirm_delete_device': `
    The registered remote device will be deleted.<br>
    To reconnect a deleted remote device, login is required from the remote location.<br>
    <br>
    <h6 class="delete-target">{name}</h6>
  `,
  'confirm_device_logoff': 'Log off the registered remote device.',
  'access-ticket': 'Control Request',
  'ticket-request': 'Control Request Management',
  'at.requested': 'Approval Requested',
  'at.re-requested': 'Re-Approval Requested',
  'at.approved': 'Approval Completed',
  'at.on-work': 'In Progress',
  'at.reject': 'Rejected',
  'at.completed': 'Completed',
  'at.Unknown': 'Unknown Status',
  'has_request_ticket': 'There are {count} control requests.',
  'deleted_device': 'The remote device has been deleted.',
  'moved_device': '[{device}] has been moved to [{group}].',
  'moved_device_by': '[{device}] has been moved next to [{group}].',
  'moved_device_fail': '{name} cannot be moved.',
  'deleted_device_count': '[{count}/{total}] remote devices have been deleted.',
  'no_order_warning': 'Group order movement is not supported. Groups will be sorted in ascending order.',
  'delete_user_confirm': 'Do you want to delete this user?',
  'delete_group_confirm': 'Do you want to delete this group?',
  'delete_checked_user_confirm': 'Are you sure you want to delete the selected users?',
  'user_active_changed': '"{name}" has been changed to "{status}".',
  'deleted_user': 'The user has been deleted.',
  'created_user': 'The user has been registered.',
  'updated_memo': 'The memo has been updated.',
  'update_agent_requested': 'Update has been requested.',
  'update_agent_desc': 'Update the remote device program on the remote device.<br>Current Version: {current_ver} > Latest Version: {latest_ver}',
  'delete_threshold': 'Do you want to delete this alert threshold?',
  'no_perm_group': 'You do not have permission for this group.',
  'add_permission_of_group': `
    Permissions on the parent group below are required to authorize this group.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'delete_permission_of_group': `
    To remove the permissions for this group, you need to remove the permissions for the subgroups below.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'please_select': 'Please select.',
  'please_input': 'Please input.',
  'please_select_device_type': 'Please select the remote device type @:please_select',
  'please_select_alert_type': 'Please select the alert type @:please_select',
  'please_input_alert_time': 'Please input the duration @:please_input',
  'please_input_alert_value': 'Please input the threshold @:please_input',
  'please_input_memo': 'Please input the memo @:please_input',
  'permissions': {
    'deviceMonitor': 'Remote Device Monitoring',
    'CSRemoteControl': 'Remote Control',
    'CSFileManager': 'File Transfer',
    'modifyInformation': 'Edit Information',
    'useFunction': 'Restart/Shutdown/Delete PC',
    'viewReport': 'View Statistics/History',
    'CSRemoteView': 'Remote View',
    'CSDeviceManagement': 'Edit/Delete Remote Device Name',
    'CSUpdate': 'Update Remote Device',
    'CSThumbnailView': 'Thumbnail View',
    'CSRestart': 'Restart PC',
  },
  'getin_with': {
    'internet_search': 'Internet Search',
    'recommendation': 'Recommendation',
    'advertising': 'Advertisement/Newspaper/Media',
    'sns': 'SNS/Blog',
    'pcany': 'PCAny Paid Customer',
    'etc': 'Others',
  },
  'added_device_in_group': 'The remote device has been added to the group.',
  'removed_device_in_group': 'The remote device has been removed from the group.',
  'changed_group_info': 'Group information has been updated.',
  'remote': {
    'remote': {
      'title': 'Remote Control',
      'title2': 'Remote Control',
      'desc': 'Starting the connection to the remote device.',
      'desc_mac': 'Do you want to start remote control?<br>(Please install the program for the first run.)',
      'activex': 'The launcher will start shortly.',
      'activex_error': 'Failed to run ActiveX.',
      'download': 'Please run the launcher once it is downloaded.',
      'launch': 'The launcher will start shortly. If it is not installed, the installer will be downloaded.',
      'application': 'The app launcher will start shortly.',
      'error': 'Failed to start the launcher.',
      'urlscheme': 'The program will start shortly.',
    },
    'transfer': {
      'title': 'File Transfer',
      'desc': 'Do you want to start file transfer?',
      'activex': 'The launcher will start shortly.',
      'activex_error': 'Failed to run ActiveX.',
      'download': 'Please run the launcher once it is downloaded.',
      'launch': 'The launcher will start shortly. If it is not installed, the installer will be downloaded.',
    },
    'reboot': {
      'title': 'System Reboot',
      'desc': '※ If the auto-start/login feature is disabled on the remote device, remote connection will not be possible. Do you want to reboot the remote device?',
      'requested': 'Reboot has been requested.',
    },
    'restart': {
      'title': 'Restart Remote Device',
      'desc': 'Restarting the remote device program.',
      'requested': 'Remote device restart has been requested.',
    },
    'shutdown': {
      'title': 'System Shutdown',
      'desc': '※ If the system is shut down, it will switch to offline mode, making remote connection impossible. Do you want to shut down the system of the remote device?',
      'requested': 'System shutdown has been requested.',
    },
    'preview': {
      'title': 'Screenshot',
    },
    'detail': {
      'title': 'Details',
    },
    'logoff': {
      'title': 'Log Off Remote Device',
    },
    'delete': {
      'title': 'Delete Remote Device',
    },
    'wol': {
      'title': 'WOL Power On',
      'desc': 'Turn on the device "{device}" via WOL using the selected equipment. Please select a device.',
      'success': 'WOL signal has been sent.',
    },
    'approve': {
      'title': 'No Control Permission',
      'desc': 'Remote Access Request',
    },
    'web': {
      'title': 'Remote Control (Web Viewer)',
    },
    'normal': {
      'title': 'Remote Control (Normal Viewer)',
    },
  },
  'columns': {
    'alive': 'Status',
    'actions': 'Actions',
    'alias': 'Remote Device Name',
    'memo': 'Memo',
    'last_connected_time': 'Last Login Time of Remote Device',
    'group': 'Group',
    'connect': 'Connect',
  },
  'id_exist': 'This ID already exists.',
  'reserved': {
    'ROOT': 'Default Group',
  },
  'audit-message': {
    '1': 'Performed the remote control function.',
    '2': 'Performed the file manager function.',
    '3': 'Restarted the system.',
    '4': 'Shut down the system.',
    '5': 'Updated the remote device to the latest version.',
    '11': 'Changed the remote device name from \'{old_value}\' to \'{new_value}\'.',
    '12': 'Changed the memo of the remote device from \'{old_value}\' to \'{new_value}\'.',
    '21': 'Moved the group from \'{old_value}\' to \'{new_value}\'.',
    '30': 'Changed from {old_value} to {new_value}.',
    '31': 'Added reservation (on): {new_value}.',
    '32': 'Added reservation (off): {new_value}.',
    '33': 'Removed the {new_value}th reservation (on).',
    '34': 'Removed the {new_value}th reservation (off).',
    '35': 'Executed remote control: {new_value}.',
  },
  'response_error_server_error': 'A temporary error occurred while loading data. Please try again later.',
  'response_error_connect_failed': 'Unable to connect to the server. Please try again later.',
  'not_supported_os': 'The operating system is not supported.',
  'alert_license': 'License Expiration Alert',
  'need_license': '{v} license is required.',
  'invalid_id_and_pw': 'Please check your ID and password.',
  'login_failed_cause_step1': 'Please check your ID and password.',
  'login_failed_cause_step2': 'Email verification has not been completed.<br>If you haven\'t received the verification email, please click the resend button.',
  'login_failed_cause_flag_active': 'The account has been deactivated.<br>Please contact the administrator.',
  'login_failed_cause_superadmin': 'External access is restricted.',
  'invalid_id': 'Please enter a valid ID.',
  'invalid_otp': 'The OTP authentication code is incorrect. Please try again.',
  'otp_token_expired': 'OTP authentication has timed out. Please log in again.',
  'name_requirement': 'Please enter your name.',
  'phone_requirement': 'Please enter your phone number.',
  'emile_requirement': 'Please enter a valid email format.',
  'subspath_requirement': 'Please enter the subscription path.',
  'company_name_requirement': 'Please enter the company name.',
  'digit_n_requirement': 'Please enter {v} digits.',
  'dont_show_again': 'Don\'t show again',
  'signup_done': 'Sign-up completed',
  'free_trial_message': '<strong>1 device free for 15 days</strong> Start enjoying remote control with LinkMeMine<br>from now on.',
  'enter_old_password': 'Enter current password',
  'enter_new_password': 'Enter new password',
  'search_location': 'Search for a location name',
  'accessable_user_desc': 'This is a list of sub-users with remote device access rights for this group.',
  'password_requirement': 'Password must be 8-12 characters and include letters, special characters, and numbers.',
  'password_confirm': 'Passwords do not match.',
  'password_modify_mail_sent': 'A password reset email has been sent.',
  'password_modified': 'Password has been changed.',
  'password_modified_failed': 'Failed to change the password.',
  'otp_reset_complete': 'OTP has been reset.',
  'otp_reset_failed': 'Failed to reset OTP.',
  'password_reset_desc': 'Please reset your password.',
  'forgot_desc': 'If resolving the issue through ID or password recovery is not possible,<br>' +
    'please contact customer support via email.<br>' +
    'You can either navigate to the inquiry page through \'Contact Us\'' +
    '<br>or send an email to Support@linkmemine.com.',
  'expired_desc': 'To continue using the service, please renew your existing license<br>or select a device to delete.',
  'expired_user_desc': 'The license has expired and you can no longer use the service.<br>Please renew your license through the administrator or remove any excess remote devices.',
  'email-invalid': 'Please enter a valid email address.',
  'id-invalid': 'Please enter a valid ID.',
  'navigate_to_home': 'Go to Home',
  'email_verification_success': 'Email verification successful',
  'email_already_verified': 'This email is already verified',
  'email_verification_failed': 'Email verification failed',
  'email_verification_pending': 'Verifying your email...',
  'email-auth-wait': 'Email verification is in progress.<br>Please wait a moment.',
  'email-auth-already': 'Email verification has already been completed.',
  'email-auth-fail': 'Email verification failed.',
  'email-auth-success': 'Email verification succeeded.<br>Please log in.',
  'login_description': 'Access all your PCs, smart devices, and IoT equipment.',
  'join_description': 'Welcome to LinkMeMine!<br>After signing up, please use the service after verifying your email sent to the registered address.',
  'go_login': 'Go to Login',
  'your_email_is': 'This ID is already registered.',
  'not_matched_user': 'No matching user found.',
  'is_pcany_customer': 'Are you currently a paying customer of PCAny?',
  'add_manager_desc': `
    <div>1. Sub-user accounts can be created and used immediately without separate email verification.</div>
    <div>2. Remote devices logged in through sub-user accounts are attributed to the admin account.</div>
    <div>3. Permissions and accessible remote device groups can be configured for each sub-user.</div>
  `,
  'free_trial_comment': 'You are currently on a free trial. Please extend the service.',
  'secure_login_desc': 'If you cannot retrieve the 6-digit security code,<br>please contact customer support.',
  'payment_tax_desc1': 'Email Inquiry: support@linkmemine.com',
  'payment_tax_desc2': 'E-payment Inquiry: 1544-7772 (Toss Payments)',
  'payment_tax_desc3': 'Contact: Customer Support 02-839-7500 (option 2)<br>support@linkmemine.com',
  'payment_tax_desc4': 'To change the number of agents or product types, please click the \'Add License\' button to apply.',
  'not_email_auth': 'A verification email has been sent.<br>Please check your inbox.',
  'email_send_fail': 'Failed to send the email. Please check the email address.',
  'mobile_store': `
    For mobile remote control,<br>
    please use the application.<br><br>
    <a href="{url}" target="_blank">Go to Store</a>
  `,
  'agreement': {
    'desc': 'Please agree to the Terms of Service and the collection/use of personal information.',
    'agree_all': 'Agree to All',
    'agree_use': 'Agree to Terms of Service',
    'agree_use_context': `
      [Terms of Services]

      LINKMEMINE, Inc. (“LINKMEMINE” or “we”) provides the LINKMEMINE Web site including the LINKMEMINE Home Page and other LINKMEMINE contents including application program (collectively, the “LINKMEMINE Site”) subject to Customer’s compliance with the terms and conditions below.

      This is a legal agreement between the individual or legal entity (“Customer” or “You”) agreeing to these Terms of Service (“Terms”) and LINKMEMINE.By accepting these Terms, signing an Order, or using the services, or checking the acceptance button on the page or application program and completing the electronic acceptance process, you represent and warrant that you

      1. are, or are authorized to sign for, the contracting party defined herein as 'Customer'.
      2. have read, understand and agree to be bound by all of the terms and conditions of this online subscription agreement.
      3. are of legal age and have authority to bind the Customer to the Order, these Terms, and the applicable “Service Descriptions” available at LINKMEMINE Site.

      PLEASE READ THIS BEFORE ACCESSING THE LINKMEMINE SITE. BY ACCESSING THE LINKMEMINE SITE, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS BELOW.   IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS AND CONDITIONS, YOU MAY NOT ACCESS OR USE THE LINKMEMINE SITE.

      This online subscription agreement ('Agreement') entered into of the date of electronic acceptance by Customer ('Effective Date'), by and between LINKMEMINE and Customer, entering into this Agreement. LINKMEMINE reserves the right to revise this Agreement from time to time without notice to Customer.


      Basic Rules

      While visiting the LINKMEMINE Site, Customer may also not: post, transmit or otherwise distribute information constituting or encouraging conduct that would constitute a criminal offense or give rise to civil liability, or otherwise use the LINKMEMINE Site in a manner which is contrary to law or would serve to restrict or inhibit any other user from using or enjoying the LINKMEMINE Site or the Internet; post or transmit any information or software which contains a virus, cancelbot, trojan horse, worm or other harmful or disruptive component; upload, post, publish, transmit, reproduce, or distribute in any way, information, software or other material obtained through the LINKMEMINE Site which is protected by copyright, or other intellectual property right, or derivative works with respect hereto, without obtaining permission of the copyright owner or rightsholder.

      You agree to use the Service in accordance with the use levels by which we measure, price and offer our Services as posted on LINKMEMINE Site, your Order, or the Service Descriptions (“Use Levels”). You may use our Services only as permitted in these Terms, and you consent to our Privacy Policy at LINKMEMINE Site.


      Services

      LINKMEMINE grants you a limited right to use LINKMEMINE Services for business and professional purposes only. Technical support for the Services is described in the Service Descriptions of LINKMEMINE Site. If your affiliates use our Services, you warrant that you have the authority to bind those affiliates and you will be liable if your affiliates do not comply with the Agreement.

      Customer may use LINKMEMINE remote software and related services only to enable a designated user to provide remote assistance to its customers. Customer may use LINKMEMINE   the Services only to enable authorized individuals to access and control designated users’ PCs and smart devices remotely.

      LINKMEMINE reserves the right to upgrade, enhance, or modify functions & features of the Services as it considers appropriate and in its discretion. LINKMEMINE will not materially reduce the core functionality (as set forth in the Service Descriptions) or discontinue any Services unless LINKMEMINE provides you with prior written notice. LINKMEMINE may offer additional functionality to our standard Services or premium feature improvements for an additional cost.

      Customer must complete the online registration process including this Agreement. LINKMEMINE may reject an online registration by a potential Customer in its sole discretion and is not obligated to provide a reason for the rejection. Customer or on behalf of Customer shall provide all registration data in accurate, current, and complete. The registration data should be updated by Customer in its sole responsibility. LINKMEMINE reserves the right to terminate this Agreement immediately in the event submitted registration data is found to be inaccurate, not current, or incomplete.

      During online registration process, LINKMEMINE will collect additional information on billing and payment related matters. It will include a valid credit card or debit card number with available credit, preferred billing frequency, and other information required by LINKMEMINE. LINKMEMINE reserves the right to terminate the Agreement immediately in the event any payment information is found to be inaccurate, not current or incomplete. Any overdraft charge or other fees that may be issued by LINKMEMINE’s use of Customer’s credit or debit card shall not be LINKMEMINE’s responsibility.

      Customer is entirely responsible for all activities under its account including management of keeping confidentiality of its password and account. Customer shall agree to inform LINKMEMINE immediately of any type of security breach. LINKMEMINE shall not be liable for any loss aroused from the Customer’s activity which may bring as a result of other entity using its password or account, either with or without its knowledge. Customer may be held liable for losses incurred by LINKMEMINE in such case as described above.

      Customer is responsible for all subscription fees and all applicable taxes (sales tax, value-added tax, goods and services tax, withholding tax, tarriffs, Universal Services Fund (USF) fees or any other similar fees and taxes) (collectively, the “Taxes and Fees”). Upon Customer’s payment of subscription fees, LINKMEMINE will allow Customer to access and use the services described above. All contents transferred by Customer or any other party in connection with Customer’s access and/or use of the services, of all kinds of communication methods, are shall be Customer’s responsibility. All payments you make to us for access to the Services are final and non-refundable. You are responsible for all fees and charges imposed by your voice and data transmission providers related to your access and use of the Services.

      Customer may order Services using our then current ordering processes (“Order”). All Orders are effective on the earlier of the date you submit your Order or the date on the signature block of the Order (collectively, the “Effective Date”). Acceptance of your Order may be subject to our verification and credit approval process.
      Customer is responsible for providing accurate and current billing contact and payment information to us or any reseller of ours. You agree that LINKMEMINE may take steps to verify whether your payment method is valid, charge your payment card or bill you for all amounts due for your use of the Services, and automatically update your payment card information using software designed to do so in the event your payment card on file is no longer valid. You agree that your credit card information and related personal data may be provided to third parties for payment processing and fraud prevention purposes. LINKMEMINE may suspend or terminate your Services if at any time LINKMEMINE determines that your payment information is inaccurate or not current, and you are responsible for fees and overdraft charges that LINKMEMINE may incur when we charge your card for payment. LINKMEMINE will not agree to submit invoices via any online portal. LINKMEMINE reserve the right to update the price for Services at any time after your Initial Term, and price changes will be effective as of your next billing cycle. LINKMEMINE will notify you of any price changes by publishing on our website, emailing, quoting or invoicing you.

      LINKMEMINE may offer a trial and/or promotional offers (promotions and other special discounted pricing offers) from time to time and the offers are temporary and upon the renewal of your subscription, any such discounted pricing offers may expire. LINKMEMINE reserves the right to discard or change coupons, credits, trials and promotional offers at its discretion and without notice. Just one (1) offer per customer is applied basically and limited to any kind of trial or promotional offers.

      You must notify us of any fee dispute within 15 days of the invoice date, and once resolved, you agree to pay those fees within 15 days. LINKMEMINE may, on notice to you, suspend or terminate your Services if you do not pay undisputed fees, and you agree to reimburse us for all reasonable costs and expenses incurred in collecting delinquent amounts.

      Customer must not reverse engineer, decompile or otherwise attempt to decipher any code in connection with the services or any other aspect of LINKMEMINE’s technology. Customer shall not access and/or use any of the services in any manner that could damage, disable, overburden, impair or otherwise interfere with or disrupt LINKMEMINE Site, services or related systems of LINKMEMINE. Customer may not resell, distribute, or use any of the services on a timeshare or disapproved method basis.


      Monitoring

      LINKMEMINE has no obligation to monitor the LINKMEMINE Site. However, Customer agrees that LINKMEMINE has the right to monitor the LINKMEMINE Site electronically from time to time and to disclose any information as necessary to satisfy any law, regulation or other governmental request, to operate the LINKMEMINE Site properly, or to protect itself or its subscribers. LINKMEMINE will not intentionally monitor or disclose any private electronic-mail message unless required by law. LINKMEMINE reserves the right to refuse to post or to remove any information or materials, in whole or in part, that, in its sole discretion, are unacceptable, undesirable, or in violation of this Agreement.


      Termination

      LINKMEMINE reserves the right to terminate this Agreement immediately if Customer breaches any of its material obligations under the Agreement. Upon termination of the Agreement, Customer will immediately stop access to and use of the services. LINKMEMINE shall not be liable for any damages resulting from a termination of the Agreement. Provided, claims arising prior to the termination shall not be affected.


      The initial term commitment for your purchase of Services will be as specified on an Order (“Initial Term”) and begins on the Effective Date. After the Initial Term, the Services will, unless otherwise specified in the Service Description for a particular Service, automatically renew for additional 1-year periods (“Renewal Terms”), unless either party provides notice of non-renewal at least 30 days before the current term expires. You may provide notice of non-renewal for each Service you do not wish to renew at LINKMEMINE Site contacts. LINKMEMINE may agree to align the invoicing under multiple Orders but this will not reduce the term of any Order. Terminating specific Services does not affect the term of any other Services still in effect. If we permit you to reinstate Services at any time after termination, you agree that you will be bound by the then-current Terms and the renewal date that was in effect as of the effective termination date.

      If the Agreement or any Services are terminated, your account may be converted to a dormant account at our discretion. Otherwise, you will immediately discontinue all use of the terminated Services, except that upon request, LINKMEMINE will provide you with limited access to the Services for a period not to exceed 30 days, solely to enable you to retrieve your Content from the Services. LINKMEMINE has no obligation to maintain your Content after that period. Neither party will be liable for any damages resulting from termination of the Agreement, and termination will not affect any claim arising prior to the effective termination date.

      You retain all rights to your Content (defined below) and LINKMEMINE does not own or license your Content. LINKMEMINE may use, modify, reproduce and distribute your Content in order to provide and operate the Services. You warrant that you have the right to upload or otherwise share Content with us, and your uploading or processing of your Content in the context of our Services does not infringe on any rights of any third party. Each party agrees to apply reasonable technical, organizational and administrative security measures to keep Content protected in accordance with industry standards. LINKMEMINE will not view, access or process any of your Content, except when it is authorized or instructed by you or your users in this Agreement or in any other agreement between the parties, or when it is required to comply with our policies, applicable law, or governmental request. You agree to comply with all legal duties applicable to you as a data controller by virtue of the submission of your Content within the Services. If your Content, including any personal data, is processed by us as a data processor acting on your behalf (in your capacity as data controller), LINKMEMINE will use and process your Content in order to provide the Services and fulfill our obligations under the Agreement, and in accordance with your instructions as represented in this Agreement. “Content” means any files, documents, recordings, chat logs, transcripts, and similar data that LINKMEMINE maintains on your or your users’ behalf, as well as any other information you or your users may upload to your Service account in connection with the Services.

      Privacy

      It is therefore recommended that the services shall not be used for the transmission of confidential information. LINKMEMINE cannot ensure or guarantee privacy for LINKMEMINE users. Any such use shall be at the sole risk of Customer and other users in connection with Customer, and LINKMEMINE and its affiliate and related companies shall be relieved of all liability in connection therewith.


      Limitation of Liability

      LINKMEMINE takes no responsibility for the accuracy or validity of any claims or statements contained in the documents and related graphics on the LINKMEMINE Site. Further, LINKMEMINE makes no representations about the suitability of any of the information contained in software programs, documents and related graphics on the LINKMEMINE Site for any purpose. All such software programs, documents and related graphics are provided without warranty of any kind. In no event shall LINKMEMINE be liable for any damages whatsoever, including special, indirect or consequential damages, arising out of or in connection with the use or performance of information available from the service. LINKMEMINE’s liability is limited to maximum $50.

      If Customer is dissatisfied with the LINKMEMINE Site or with any terms, conditions, rules, policies, guidelines, or practices of LINKMEMINE in operating the LINKMEMINE Site, Customer’s sole and exclusive remedy is to discontinue using the LINKMEMINE Site.


      Confidential Information
      Both parties shall not disclose non-public information or materials which are reasonably understood to be confidential (“Confidential Information”) except the case of any information that receiving party of Confidential Information is obligated to produce pursuant to an order of a court of competent jurisdiction with timely notice to disclosing party. Customer will keep in strict confidence all passwords and other access information to the services.

      Customer shall authorize LINKMEMINE to collect from any party and to retain all relevant information relating to Customer’s use of the LINKMEMINE Site, and hereby authorize any party to provide LINKMEMINE with such information. Customer shall understand and agree that unless Customer notify LINKMEMINE to the contrary by e-mailing, Customer further authorize LINKMEMINE to disclose, on a confidential basis, to any party with whom LINKMEMINE has business relations all relevant information relating to Customer’s dealings with LINKMEMINE and the LINKMEMINE Site.


      Indemnity

      Customer agrees, at its sole expense, to defend, indemnify and hold LINKMEMINE and its affiliate and related companies harmless from any and all liabilities, costs and expenses, including reasonable attorneys' fees, related to a third party claim, suit, or infringement based on information, data, or any content submitted by Customer or related to any Violation of this Agreement by Customer or users of Customer’s account, or in connection with the use of the LINKMEMINE Site or the Internet or the placement or transmission of any message, information, software or other materials on the LINKMEMINE Site or on the Internet by Customer or users of Customer’s account.



      Trademarks & Proprietary Rights

      LINKMEMINE and other names, logos and icons identifying LINKMEMINE and LINKMEMINE' products and services referenced herein are trademarks or registered trademarks of LINKMEMINE, Inc. All other product and/or brand or company names mentioned herein are the trademarks of their respective owners. LINKMEMINE, Inc. retains ownership of all proprietary rights in or associated with all its products and services.


      DISCLAIMER
      CUSTOMER HEREBY ACKNOWLEDGES AND AGREES THAT ALL MATERIALS CONTAINED IN THE SERVICES IS PROVIDED BY LINKMEMINE ON AN "AS IS" BASIS, AND CUSTOMER’S ACCESS TO AND/OR USE OF THE SERVICES IS AT ITS SOLE RISK WITHOUT WARRANTY OF ANY KIND. THE ENTIRE RISK AS TO THE RESULTS AND THE PERFORMANCE OF THE SOFTWARE IS ASSUMED BY THE USER, AND IN NO EVENT WILL LINKMEMINE BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL OR DIRECT DAMAGES SUFFERED IN THE COURSE OF USING THE SOFTWARE IN THE SERVICES. USE OF ANY MATERIAL AND/OR DATA DOWNLOADED OR OBTAINED PROGRAMS (INCLUDING PLUG-INS) CONTAINED IN THE SERVICES IS DONE AT THE SOLE RISK OF CUSTOMER. CUSTOMER WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO ITS COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA.


      Headings

      The headings used in this Agreement are used for convenience only and are not to be considered in construing or interpreting this Agreement.


      Force Majeure

      LINKMEMINE shall not be responsible for delays or failure to perform resulting from acts beyond the reasonable control of such party and which could not have been reasonably foreseen and provided against and with respect to which such party shall exercise continuing diligence to resume performance of its obligations. Such acts shall include, without limitation, acts of God, fires, casualties, floods, earthquakes, acts of war, strikes, lockouts, epidemics, destruction of production facilities, riots, insurrections, walkouts, government order, power failures, and other disasters.


      No Waiver & Severability

      The failure of either Customer or LINKMEMINE in any one or more instance(s) to insist upon strict performance of any of the terms of this Agreement will not be construed as a waiver or relinquishment of the right to assert or rely upon any such term(s) on any future occasion(s). In the event that any provision of this Agreement (or portion thereof) is determined by a court of competent jurisdiction to be invalid or otherwise unenforceable, such provision (or part thereof) shall be enforced or, incapable of such enforcement, shall be deemed to be deleted from this Agreement, while the remainder of this Agreement shall continue to remain in full force and effect according to its stated terms and conditions.


      COMPLIANCE WITH LAWS. IN CONNECTION WITH THE PERFORMANCE, ACCESS AND USE OF THE SERVICES UNDER THE AGREEMENT, EACH PARTY AGREES TO COMPLY WITH ALL APPLICABLE LAWS, RULES AND REGULATIONS INCLUDING, BUT NOT LIMITED TO EXPORT, PRIVACY, AND DATA PROTECTION LAWS AND REGULATIONS. IF NECESSARY AND IN ACCORDANCE WITH APPLICABLE LAW, LINKMEMINE WILL COOPERATE WITH LOCAL, STATE, FEDERAL AND INTERNATIONAL GOVERNMENT AUTHORITIES WITH RESPECT TO THE SERVICES. NOTWITHSTANDING ANY OTHER PROVISION IN THESE TERMS, WE MAY IMMEDIATELY TERMINATE THE AGREEMENT FOR NONCOMPLIANCE WITH APPLICABLE LAWS.


      WARRANTIES. WE WARRANT THAT THE SERVICES WILL CONFORM TO THE SERVICE DESCRIPTIONS UNDER NORMAL USE. WE DO NOT REPRESENT OR WARRANT THAT (1) THE USE OF OUR SERVICES WILL BE TIMELY, UNINTERRUPTED OR ERROR FREE, OR OPERATE IN COMBINATION WITH ANY SPECIFIC HARDWARE, SOFTWARE, SYSTEM OR DATA, (2) OUR SERVICES WILL MEET YOUR REQUIREMENTS, OR (3) ALL ERRORS OR DEFECTS WILL BE CORRECTED. USE OF THE SERVICES IS AT YOUR SOLE RISK. OUR ENTIRE LIABILITY AND YOUR EXCLUSIVE REMEDY UNDER THIS WARRANTY WILL BE, AT OUR SOLE OPTION AND SUBJECT TO APPLICABLE LAW, TO PROVIDE CONFORMING SERVICES, OR TO TERMINATE THE NON-CONFORMING SERVICES OR THE APPLICABLE ORDER, AND PROVIDE A PRO-RATED REFUND OF ANY PREPAID FEES FROM THE DATE YOU NOTIFY US OF THE NON-CONFORMANCE THROUGH THE END OF THE REMAINING TERM. TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL OTHER WARRANTIES AND CONDITIONS, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY EXPRESS OR IMPLIED WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES AND CONDITIONS, THEREFORE SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO CUSTOMERS LOCATED IN THOSE JURISDICTIONS.
    `,
    'agree_privacy': 'Accept to the collection/use of personal information',
    'agree_privacy_context': `
      [Privacy Policy]

      LinkMeMine service, as described in Terms of Service of LinkMeMine Site, is a remote support service provided by LinkMeMine, Inc. In this Privacy Policy, we explain what personal data we collect from visitors to the LinkMeMine website(s) and/or properties that link to this Privacy Policy (including digital properties) and how we use such personal data.

      Your privacy is important to us. To protect your privacy better, we provide this policy explaining our online information practices and the choices you can make about the way your information is collected and used. To make this policy easy to find, we make it available on our website(s) and at every point where personally identifiable information may be requested.

      When you visit our website(s), and/or use our Services, you provide following personal data to us.

      Data Information and Collection

      This notice applies to all information collected or submitted on the LinkMeMine Site. On some pages, you can order products, make requests, and register to receive services and related materials. The types of personal information that you provide at these pages are typically including first and last name, billing data, and a valid email address, postal address, and other demanding information for the service when you create your account with us, request support or technical assistance, or register for events, webinars, whitepapers and surveys.
      We need this data to provide the Services to you, to maintain and support your account, as well as to collect payment. Legal basis for the processing of this data is our legitimate interest to do business with you, your employer or business and perform our contractual obligations under the applicable Services agreement.

      When you use our Services, we receive information through the use of the Service, either voluntarily entered by you or others who use the Services with you, or from the Service infrastructure itself. Service Data includes session and usage data, device information, as well as data automatically logged by the website(s) or Services, for example, duration of session, connections made, hardware, equipment and devices used, IP addresses, location, language settings, operating system used, unique device identifiers, IP addresses and other diagnostic data to help us provide better Services.


      Use of Information Collected

      We use the information you provide about yourself when you are using our services, placing and completing an order, and doing other activities of or related to our website(s) and services. We do not share this information with outside parties except to the extent necessary to maintain the services, to complete that order, to confirm processes, and to analyze our website(s).
      We use the data we collect from visitors to our website(s).
      1) to provide and operate our Services;
      2) to maintain and improve our Services;
      3) to provide product updates, marketing communications, and service data;
      4) to provide analysis or valuable data back to our customers and users;
      5) to address and respond to service, security, and customer support needs;
      6) to detect, prevent, or otherwise address fraud, security, unlawful, or technical issues;
      7) to display content based upon your interests;
      8) to comply with applicable laws and administrative requests, protect our rights, assert and defend against claims;
      9) to fulfill contracts;
      10) to assess the needs of your business to determine and promote other related products which we believe may be helpful to you;
      11) to conduct research and analysis for business planning and product development;
      12) to the extent permitted by law, we may combine, correct and enrich personal data that we receive from you with data about you from other sources, including publicly available databases or from third parties to update, expand and analyze our records, identify new prospects for marketing, and provide products and Services that may be of interest to you.
      We continuously improve our website(s) and Services through the use of web analytics tools and first and third-party cookies, which help us understand how our visitors use our website(s), desktop and mobile applications, what webpages, features and functions they like and dislike, and where they may have run into problems which need to be addressed.

      We use non-identifying and aggregate information to better design our website(s) and to share with advertisers. For example, we may tell an advertiser that X number of individuals visited a certain area on our website(s), or that Y number of men and Z number of women filled out our registration form, but we would not disclose anything that could be used to identify those individuals.

      We never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.
      Data Security

      To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.

      Within our organization, we apply access controls to limit the recipients of personal data on a "need to know" basis. Our customer support and technical staff, billing and finance personnel, and representatives of our legal and audit departments have access to your data as necessary for the legitimate purposes of our data processing


      Children's Privacy
      Protecting the privacy of the very young is especially important. For that reason, we do not seek through our sites to gather personal data from or about persons that are minors (i.e., not the age of majority). If you inform us or we otherwise become aware that we have unintentionally received personal data from a minor, we will delete this information from our records.

      Access or Correct Your Information

      We update this Privacy Policy from time to time to reflect changes to our personal data handling practices or respond to new legal requirements and will post updates here. However, if we make any material changes that have a substantive and adverse impact on your privacy, we will provide notice on this(these) website(s) and additionally notify you by email (sent to the e-mail address specified in your account) for your approval prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.

      You can access all your personally identifiable information that we collect online and maintain by login procedure. We use this procedure to better safeguard your information.

      You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error.

      To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.



      Contact Us

      Subject to conditions specified by applicable law, persons have the right:
      1) to inquire whether and what kind of personal data we hold about you and how it is processed, and to access or request copies of such personal data;
      2) to request the correction or supplementation of personal data about you that is inaccurate, incomplete or out-of-date in light of the purposes underlying the processing;
      3) to request to obtain the erasure of personal data no longer necessary for the purposes underlying the processing, processed based on withdrawn consent, processed for legitimate interests that, in the context of your objection, do not prove to be compelling or necessary for the establishment, exercise or defense of legal claims, or processed in non compliance with applicable legal requirements.

      In addition, you have, subject to the conditions set out in applicable law and without limitation, the rights:
      1) to request us to restrict the processing of personal data in certain situations where you feel its processing is inappropriate;
      2) to object, on grounds relating to your particular situation or where your personal data is used for direct marketing purposes, to the processing of personal data for legitimate interests;
      3) to request portability of personal data that you have provided to us, where the processing of such personal data is based on consent or a contract with you and is carried out by automated means. In case of concerns, you also have the right to lodge a complaint with a supervisory authority having appropriate jurisdiction.

      Under certain circumstances we will not be able to fulfill your request, such as if it interferes with our regulatory obligations, affects legal matters, we cannot verify your identity, or it involves disproportionate cost or effort, but in any event, we will respond to your request within thirty (30) days and provide you an explanation.
      If you have questions or requests relating to our privacy practices and this Privacy Policy or would like to exercise the mentioned (above) rights of access, rectification, erasure, restriction, objection and data portability, you may contact us using contact information at our website(s).
      Please note that for personal data about you that we have obtained or received for processing on behalf of a separate, unaffiliated entity – which determined the means and purposes of processing, all such requests should be made to that entity directly. We will honor and support any instructions they provide us with respect to your personal information.
      If you wish to no longer receive marketing communications from us, you also can contact via the contact information of our website(s).
    `,
  },
  'help_otp': `
    <h5>2-Step Verification Setting using Google OTP</h5>
    <section style="margin:30px 0;">
      <h6>1. Activate 2-Step Verification (OTP)</h6>
      <p style="margin-left: 12px;">Click to slide the toggle switch to activate (it should turn green).<br>
      Click to reset OTP settings.</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Install Google OTP from Google Play Store or the App Store.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Run Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. Logout and log back in. You should see a window to register Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Select barcode scan in the Google OTP app and register.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. Enter in the 6-digit verification code and login.</h6>
    </section>
  `,
  'help_manager': `
    <h5>What are submanager permission?</h5><br>
    <b>Submanager ("Approved by")</b>: Can modify user permission and approve or deny remote access request.<br><br>
    <b>User ("Requested by")</b>: Can be approved by the submanager to access and monitor device(s).
  `,
  'help_vaccine': `
    <h5>Allowed Program Help</h5><br>
    <h6> Enter the name of the installed program (excluding .exe files) to allow.
    </h6>
    <h6 style="padding:0 0 20px 0;">(Leave blank if not using any program)</h6>
  `,
  'help_os': `
    <h5>OS Version Help</h5><br>
    <h6 style="padding:0 0 20px 0;">
      Check the version of your OS below and enter the appropriate number.<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">Major Version</th>
      <th>Minor Version</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'help_email': `
    <h5>Why is it necessary to provide an email address and phone number?</h5><br>
    <div style="margin-left: 12px;">1. For retrieving your ID and password</div>
    <div style="margin-left: 12px;">2. For unlocking dormant or locked accounts</div><br>
    These are required to use these features.
  `,
  'help_searchPW': `
    A password reset email will be sent to the registered email address.
  `,
  'ip_delete_all_warning': 'Do you want to delete the entire IP list?',
  'ip_delete_all': 'Delete All IPs',
  'ip_block_reject': `This IP is blocked by the block policy.<br>Please contact the administrator.`,
  'ip_white_reject': `This IP is blocked by the allow policy.<br>Please contact the administrator.`,
  'search_manager_200': `The approver has been set.`,
  'search_manager_405': `Please verify the approver's ID.`,
  'search_approver_null': 'If left blank, the administrator will be automatically set as the approver.',
  'date_validate_error': 'Please check the requested date.',
  'approvals_reason': 'Please enter the reason for the request.',
  'search_approver_placeholder': 'Enter the approver\'s ID',
  'approval-success': `
    The access permission request has been processed.
  `,
  'function-settings-desc01': 'Allows or blocks file transfer functionality for sub-managers and users.',
  'blocking-settings-desc01': 'Register blocked IPs to restrict access.',
  'blocking-settings-desc02': 'Register allowed IPs to permit access only to the registered IPs.',
  'function-submit': 'Function settings have been updated.',
  'blocking-submit': 'Block/allow settings have been updated.',
  'blocking-super-settings-desc': 'Uses the IP management settings.',
  'reset-pw-repeat': 'Do you want to reset the password?',
  'reset-pw-submit': 'The password has been reset.<br>Password: koino1807!',
  'registration-access': 'The access permission request has been approved.',
  'registration-reject': 'The access permission request has been rejected.',
  'registration-access-error': 'The access permission request cannot be approved if a rejection reason is entered.',
  'registration-reject-error': 'Please enter a rejection reason.',
  'login_failed_cause_ip_reject': 'Access is blocked due to IP restriction policies.',
  'login_failure_limit': 'You have exceeded the allowed number of login attempts.<br>Please contact the administrator or verify your email.',
  'registration-approve': 'Process',
  'registration-reject-history': 'Do you want to reject the approval history?',
  'help_ip_add': `
    <h5>IP Addition Help</h5><br>
    <h6 style="font-weight:bold;">
      Add a Single IP
    </h6>
    <h6 style="padding:0 0 20px 0;">Only the entered single IP address will be added.</h6>
    <h6 style="font-weight:bold;">
      Add an IP Range
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP addresses within the entered start and end addresses will be added.<br>
      Example: 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      Add a Subnet
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP addresses divided by subnetting will be added.<br>
      Example: 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Add via Excel
    </h6>
    <h6 style="padding:0 0 20px 0;">
      Click <span style="color:#38d2b8;font-weight:bold;">'Download Excel Template'</span> below to download the template,
      fill in the details, and upload it.<br><br>
      You can add single IPs and subnet IPs.<br>
      Enter the IP in the start address and leave the end address empty.<br><br>
      For range IPs, enter both the start and end addresses.<br><br>
      Only correctly entered IP addresses will be added.
    </h6>
  `,
  'ip_range_error': 'Please check the IP address.<br><br>',
  'ip_range_blank': 'Please enter the IP address.',
  'ip_excel_no_file': 'Please upload an Excel file.',
  'user_in_group_add': 'Enter the ID of the user to add.',
  'user_in_group_no_exist': 'The user does not exist.',
  'user_in_group_overlap': 'The user is already in the group.',
  'user_in_group_blank': 'Enter the ID of the user to add.',
  'user_in_group_add_success': 'The user has been added to the group.',
  'user_in_group_remove_success': 'The user has been removed from the group.',
  'start_time_ch': 'Select start date',
  'start_time_time': 'Select start time',
  'end_time_ch': 'Select end date',
  'end_time_time': 'Select end time',
  'auth_failure_num_desc': 'If login attempts exceed the number set by the administrator, the account will be locked.',
  'auto_block_time': 'If no activity occurs beyond the set time after remote access, the session will be automatically terminated.',
  'os_version_desc': 'Checks the user\'s environment and allows access only for Windows versions specified in the policy settings.',
  'session_timie_desc': 'Remote sessions exceeding the set time will be automatically terminated, even if in use.',
  'password_level_desc': 'Adjusts the password complexity when creating a user.',
  'capture_desc': 'Allows or blocks screen capture and recording features for sub-managers and users.',
  'display_power_save_desc': 'Prevents the remote PC\'s display from entering power-saving mode during remote sessions.',
  'system_power_save_desc': 'Prevents the remote PC\'s system from entering power-saving mode during remote sessions.',
  'security_agreement_desc': 'Restricts access to users who agree to the security agreement.',
  'function_settings_header': '* Policy Management: Administrators can set policies applied to remote features and access environments for sub-managers and users.',
  'vaccine_desc': 'Allows access only in environments where the specified process/service name is running.',
  'invalid_idle_time': 'Please check the remote idle time (minutes).',
  'invalid_session_time': 'Please check the remote session duration (minutes).',
  'invalid_block_num': 'Please check the allowed number of authentication failures.',
  'invalid_min_os_major': 'Please check the minimum major OS version.',
  'invalid_min_os_minor': 'Please check the minimum minor OS version.',
  'password_modified_error': 'Please verify the current password.',
  'password_change_limit': 'The password usage period has expired.<br>Please change your password.',
  'password_expired_desc': 'Passwords must be changed upon expiration of the set period to log in.',
  'self_unlock_desc': 'Allows users to unlock their accounts directly through identity verification.',
  'invalid_password_change_limit': 'Please check the maximum password usage period (days).',
  'help_PWChangeLimit': `
    <h5>Password Maximum Usage Period Help</h5><br>
    <h6 style="line-height:1em;">
      Sets the maximum period a password can be used.<br>
      You can set up to 365 days (1 year).<br>
    </h6>
    <h6 style="padding:20px 0 0 0">
      (Enter 0 to disable the maximum password usage period.)
    </h6>
  `,
  'excel_onloaded': 'Only correctly filled sub-users will be displayed.<br>Select the sub-users to register and click the register button.',
  'excel_user_submit': 'All account information except for {failure} failures has been registered.',
  'excel_group_submit': 'All group information except for {failure} failures has been registered.',
  'excel_group_fail': 'Failed to register group information in bulk.<br>Please check the information entered in the Excel file.',
  'groups': 'Groups',
  'users': 'User Management',
  'dashboard': 'Statistics/History',
  'payment_manage': 'Payment',
  'subscription': 'Add/Renew License',
  'payment_history': 'Payment History',
  'deleted_device_history': 'Deleted Device History',
  'add_sub_user': 'Add Sub-user',
  'add_group': 'Add Group',
  'access_time': 'Access Time',
  'no_devices': 'No Remote Devices',
  'add_ip': 'Add IP',
  'delete_ip': 'Delete IP',
  'add_ip_single': 'Add Single IP',
  'add_ip_range': 'Add IP Range',
  'add_ip_subnet': 'Add Subnet',
  'add_ip_excel': 'Add via Excel',
  'device_excel_fail': 'Failed to generate remote device list in Excel.',
  
  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'mode_change': 'Switch Mode',
  'mode_change_simple': 'Simple Mode',
  'mode_change_normal': 'Normal Mode',
  'icon_access': 'Accessible',
  'icon_online': 'Online',
  'icon_offline': 'Offline',
  
  'agent_policy': 'Remote Device Policy',
  'agent_restart_time': 'Scheduled Restart Time for Remote Devices (Daily)',
  'agent_restart_desc': 'Sets a scheduled restart time for remote devices to improve connection stability. During this time, remote devices will automatically restart and reconnect sequentially. It is recommended to set this during low-usage periods to avoid disruptions. This applies only to online Windows and Android remote devices.',
  'agent_group_update': 'Bulk Update Remote Devices',
  'agent_group_desc': 'Updates online Windows remote devices to the latest version. Updates are applied sequentially, and devices reconnect automatically after completion.',
  'agent_update': 'Update',
  'batch_update_desc': 'Performs a bulk update to the latest version of remote devices.',
  
  'statistics_policy': 'Set Statistics History Cycle',
  'statistics_period': 'Cycle',
  'day': 'Day',
  'month': 'Month',
  'year': 'Year',
  
  'excel_button': 'Excel',
  'no-agent-selected': 'No remote devices selected.',
  
  'add-group-child': 'Add Group _Subgroup',
  'equipment_not_registered_msg': 'The device is not registered.',
  'max_device_limit_reached_msg': 'You have reached the maximum number of allowed devices.<br>To add more, please delete existing devices.',
  'user_registered_agent': 'My Devices',
  
  'concurrent_users': 'Concurrent Users',
  'max_device_alert': 'Basic licenses cannot register more than {maxDevices} devices.',
  'min_device_alert': 'Corporate licenses must register at least {minDevices} devices.',
  'min_concurrent_sessions_alert': 'LMM1000+ licenses cannot register less than {minConcurrentSessions} concurrent users.',
  'addLicense': 'Make Payment',
  'internal': 'Management',
  'external': 'Access',
  'payment_account_info': '<b>Account Number:</b> 1005-101-071339<br>\n' +
    '<b>Bank:</b> Woori Bank<br>\n' +
    '<b>Account Holder:</b> Koino Co., Ltd.<br>\n' +
    '<small>(Please confirm deposits via chat consultation)</small>',
  'password_reset_email_send': 'Password reset email sent',
  'in_progress_request': 'Request in progress',
  
  'no_data_available': 'No data available.',
  'agree_and_connect': 'Agree and Connect',
  'decline_and_cancel': 'Decline and Cancel',
  'security_agreement': 'Security Agreement',
  'approval_type': 'Approval Type',
  'approval_line': 'Approval Line',
  'application_reason': 'Reason for Application',
  'manual_input': 'Manual Input',
  'pre_approval': 'Pre-Approval',
  'post_approval': 'Post-Approval',
  'exception': 'Exception',
  'selection': 'Selection',
  'application_datetime': 'Application Date and Time',
  'remote_device_name': 'Remote Device Name',
  'delete_registered_remote_device': 'Delete Registered Remote Device',
  'confirm_delete_registered_device': 'Do you want to delete the registered remote device below?',
  'device_deletion_logout_notice': 'Deleting a registered remote device will log it out and disable the auto-login feature.',
  'remote_device_registration_request': 'Remote Device Registration Request',
  'memo': 'Memo',
  'registration_datetime': 'Registration Date and Time',
  'step_n': 'Step {n}',
  'apply': 'Apply',
  'user_kr': 'User',
  'policy_manager': 'Manager',
  'mid_manager': 'Sub-manager',
  'admin_privileges': 'Administrator Privileges',
  'manager_name': 'Manager Name',
  'delete_registered_manager': 'Delete Registered Manager',
  'confirm_delete_registered_manager': 'Do you want to delete the registered manager below?',
  're_register_manager_approval_required': 'To re-register a deleted manager, approval for manager registration is required.',
  'last_login_datetime': 'Last Login Date and Time',
  'add_user': 'Add User',
  'shared_group': 'Shared Group',
  'approval_process': 'Approval',
  'select_delete': 'Delete Selected',
  'recording': 'Recording',
  'success': 'Success',
  'start_datetime': 'Start Date and Time',
  'end_datetime': 'End Date and Time',
  'enter_content': 'Please enter content.',
  'manager_str': 'Manager',
  'prior': 'Prior',
  'post': 'Post',
  'category': 'Category',
  'pledge_version': 'Pledge Version',
  'error_code': 'Error Code',
  'pledge': 'Pledge',
  'start_date_str': 'Start Date',
  'end_date': 'End Date',
  'toasts_message': {
    'key_is_required': '{key} is a required field.',
    'enum_error': '{key} can only have values from [{allowed_values}].',
    'select_department_to_delete': 'Please select a department to delete.',
    'excel_no_data': 'There is no data in the Excel file.',
    'department_bulk_register': 'All department information except for {failure} failures has been registered.',
    'select_file': 'Please select a file.',
    'no_data_to_download': 'No data available for download.',
    'group_move_not_allowed': 'This group is \'All Devices.\' Group movement is not allowed.',
    'data_fetch_failed': 'Failed to fetch data.',
    'no_data_to_download_excel': 'No data available to download in Excel format.',
    'no_selected_applicants': 'No applicants have been selected.',
    'approval_completed': 'Approval has been completed.',
    'no_selected_department_members': 'No department members have been selected.',
    'remote_device_deleted': 'The remote device has been deleted.',
    'version_applied': 'The version has been applied.',
    'save_success': 'Saved successfully.',
    'manager_deleted': 'The manager has been deleted.',
    'select_user_to_delete': 'Please select a user to delete.',
    'no_department_info': 'There is no department information.',
    'required_field_message': '{key} is a required field.',
    'invalid_enum_value': '{key} can only have values from [{values}].',
    'department_name_not_found': 'The department name does not exist.',
  },
  'join_form': {
    'required_field': 'Required Field',
    'optional_field': 'Optional Field',
  },
  'login_page': {
    'popup_block': 'A pop-up blocker has prevented the pop-up.<br>Please disable the pop-up blocker and refresh the page.',
    'mobile_block': 'This service is not available in a standard web browser.<br>Please use the LinkMeMine mobile app.',
    'waiting': 'Checking user environment and manager registration status.<br>Please download and run the EXE for the environment check.',
    'app_download': 'App Download',
    'manual_download': 'Manual Download',
    'internal_tooltip': 'Download the manual for installing and managing remote devices.',
    'external_tooltip': 'Download the manual for remotely accessing installed devices.',
    'auto_login': 'Auto Login',
    'warning_massage1': 'The device attempting to log in is currently in<br><em class="text-danger">an approval pending state after registration application</em>.',
    'warning_massage2': 'To proceed with registration, please request approval<br>from the manager designated as the approver during registration.',
    'warning_massage3': 'If you do not wish to register, please request rejection<br>from the manager designated as the approver during registration.',
    'download_android_remote_device': 'Download Android Remote Device',
  },
  'department_page': {
    'add_department': 'Add Department',
    'bulk_add_department': 'Bulk Add Departments',
    'department_delete': 'Delete Department',
    'department_manage': 'Manage Departments',
    'department_name': 'Department Name',
    'department_created': 'The department has been created.',
    'department_deleted': 'The department has been deleted.',
    'confirm_department_delete': 'Do you want to delete this department?',
  },
  'device_page': {
    'public_access_warning': 'Public Access Prohibited Warning',
    'default_group': 'Default Group',
    'update': 'Update',
    'device_favorite_removed': 'The favorite for the device {alias} has been removed.',
    'device_favorite_added': 'The device {alias} has been added to favorites.',
    'device_moved_to_group': 'The device `{alias}` has been moved to the group of {node.name}.',
    'remote_device_list': 'Remote Device List',
    'self_registration': 'Self Registration',
    'remote_device_group_name': 'Remote Device Group Name',
    'remote_device_already_exists': 'The remote device already exists.',
    'all_devices': 'All Devices',
    'self_registered_remote_device': 'Self-Registered Remote Device',
  },
  'dialogs_page': {
    'security_pledge': 'Security Pledge',
    'security_pledge_desc': {
      'items': [
        'I will perform remote access from the designated workplace.',
        'I will thoroughly manage documents or information viewed, created, saved, or printed during remote access and will not leak them externally.',
        'To prevent virus infection or spread, I will install and operate antivirus software on the remote access computer and keep the antivirus engine up to date.',
        'I will set up screen protection during remote access and require a password for screen recovery.',
        'I will manage the assigned ID, password, and security information carefully to prevent external leakage.',
        'If I become aware that my ID, password, or security information has been leaked, I will immediately request suspension of use and reissue them.',
        'I will not perform unauthorized actions such as file transfers, screen captures, or recordings. If necessary, I will ensure proper security measures are in place and report to a higher manager before proceeding.',
      ],
      'confirmation': 'I pledge to comply with the above and accept any disciplinary action or disadvantages under company rules and relevant laws if I violate these terms.',
    },
    'remote_application_form': 'Remote Application Form',
    'duplicate_error': 'Duplicate Error',
    'change_start_date_and_retry': 'Please change the start date and try again.',
    'select_approval_line': 'Please select an approval line.',
    'application_info': 'Application Information',
    'registered_remote_device_info': 'Registered Remote Device Information',
    'max_registration_allowed': 'Maximum Registration Allowed',
    'current_registration': 'Current Registration',
    'registration_in_progress': 'Registration in Progress',
    'exceeded_remote_device_limit': 'The number of registrable remote devices has been exceeded.',
    'remove_or_revoke_pending_requests': 'Please delete currently registered remote devices or withdraw pending requests/approvals and try again.',
    're_registration_requirements': 'To re-register deleted remote devices, you must uninstall the program from the local device where the remote device is installed, reinstall, log in, and reapply for registration and approval.',
    'remote_device_registration_exceeded': 'Exceeded Remote Device Registration Limit',
    'enter_remote_device_name': 'Please enter the remote device name.',
    'remote_device_registration_completed': 'Remote device registration has been completed.',
    'approver_selection': 'Approver Selection',
    'approval_line_limit': 'Approval line can be reflected only after selecting up to {limit} approvers.',
    'user_environment_check_result': 'User Environment Check Result',
    'inspection_item': 'Inspection Item',
    'description': 'Description',
    'result': 'Result',
    'add_selection': 'Add Selection',
    'select_user_to_add': 'Please select a user to add.',
    'registered_manager_info': 'Registered Manager Information',
    'manager_registration_limit_exceeded': 'The number of registrable managers has been exceeded.',
    'remove_or_revoke_pending_manager_requests': 'Please delete currently registered managers or withdraw pending requests/approvals and try again.',
    'manager_registration_request': 'Manager Registration Request',
    'manager_registration_request_exceeded': 'Exceeded Manager Registration Request Limit',
    'enter_manager_name': 'Please enter the manager\'s name.',
    'manager_registration_completed': 'Manager registration has been completed.',
    'send_email': 'Send Email',
  },
  'error_page': {
    'logout_completed': 'You have been logged out.',
    'invalid_access': 'Invalid access.',
    'manager_registration_required': 'This is an unregistered manager.<br>Please apply through the manager registration request popup.<br>If the popup does not appear, disable the popup blocker.<br>Reconnect after manager registration application and approval.',
    'invalid_access_vpn': 'Invalid access.<br>Please connect using the VPN app.',
    'session_expired': 'Your session has expired.',
    'manager_registration_success': 'Manager registration request has been completed.<br>Reconnect after approval of the manager registration application.',
  },
  'groups_page': {
    'group_access_user_remote_device_list': 'List of remote devices registered by group access users',
    'shared_group_management': 'Shared Group Management',
    'duplicate_value_detected': 'Duplicate value detected: ',
    'select_group_to_delete': 'Please select a group to delete.',
    'group_deletion': 'Group Deletion',
  },
  'management_page': {
    'requester': 'Requester',
    'approver': 'Approver',
    'delete_device': 'Delete Device',
    'enter_device_name': 'Enter the device name.',
    'remote_device_registration_history': 'Remote Device Registration History',
    'application_date': 'Application Date',
    'application_time': 'Application Time',
    'approval_datetime': 'Approval Date and Time',
    'approval_status': 'Approval Status',
    'approval_date': 'Approval Date',
    'approval_time': 'Approval Time',
    'final_approver': 'Final Approver',
    'remote_device_registration_request_approval': 'Approval for Remote Device Registration Request',
    'select_approval': 'Select Approval',
    'confirm_remote_device_approval': 'Do you want to approve the above remote device registration request(s)?',
    'remote_device_integration_management': 'Remote Device Integration Management',
    're_registration_requirements': 'To re-register a deleted remote device, approval for the remote device registration request is required.',
    'registration_date': 'Registration Date',
    'registration_time': 'Registration Time',
    'deletion_datetime': 'Deletion Date and Time',
    'deletion_date': 'Deletion Date',
    'deletion_time': 'Deletion Time',
    'remote_device_registration_deletion_history': 'Remote Device Registration/Deletion History',
    'deleter': 'Deleter',
    'ip_management_policy': 'IP Management Policy',
    'block_blacklist_ip': '(Block-Blacklist) Block registered access IPs',
    'block_blacklist_disabled': '(Block-Blacklist) Not Used',
    'start_ip_address': 'Start IP Address',
    'end_ip_address': 'End IP Address',
    'approval_information': 'Approval Information',
    'no_approval_information': 'No Approval Information Available',
    'pending': 'Pending',
    'approval_opinion': 'Approval Opinion',
    'remote_work': 'Remote Work',
    'incident_response': 'Incident Response',
    'dispatch': 'Dispatch',
    'maintenance': 'Maintenance',
    'security_pledge_management': 'Security Pledge Management',
    'version_settings': 'Version Settings',
    'enter_version': 'Enter the version.',
    'applied_version': 'Applied Version',
    'version_management': 'Version Management',
    'new_registration': 'New Registration',
    'user_remote': 'User Remote',
    'user_remote_approval_process': 'User Remote Approval Process',
    'user_remote_approval_policy_activation': 'Enable the user remote approval process policy to set exceptions/applications for each user.',
    'approval_process_applied_policy': 'For users with an applied approval process, remote control is only available after remote request approval. (Pre-Approval) For users with post-approval rights, remote requests with post-approval allow immediate remote control upon approval.',
    'approval_process_usage': '① Use: Set exceptions/applications for each user in the approval process.',
    'approval_process_not_applied_to_existing_exceptions': '- Switching to use does not apply to existing exception users in the approval process.',
    'approval_process_not_used': '② Not Used: Remote connection without the approval process for all users.',
    'approval_process_disabled_effect': '- Switching to not use allows remote connections without approval for users under the approval process.',
    'remote_and_connection_maintenance_policy': 'Remote and Connection Maintenance Policy',
    'remote_and_connection_policy_applies_to_all': 'The remote and connection maintenance policy applies to the entire system and users.',
    'remote_control_file_transfer': '1. Remote Control, File Transfer',
    'block_remote_control_file_transfer': '① Block: Block remote control and file transfer for all users.',
    'block_applies_to_all_users': '- Blocking applies to all users, even those previously granted permissions.',
    'allow_user_permissions': '② Allow: Set permissions for each user.',
    'allow_transition_no_access': '- Allowing does not grant access to users without previous permissions.',
    'system_user_bulk_apply': '2. Bulk application items for the entire system and users.',
    'screen_capture_recording_lock': '- Screen capture and recording, keyboard/mouse lock, screen blocking (black screen).',
    'screen_saver_power_saving': '- Screen saver, screen power saving, system power saving.',
    'forced_idle_logout_manager': '- Forced logout (manager), idle auto-logout (manager).',
    'forced_idle_termination_viewer': '- Forced termination (viewer), idle auto-termination (viewer).',
    'public_access_prohibited_warning': 'Public Access Prohibited Warning',
    'accept_and_save': 'Accept and Save',
    'windows_process_service_detection': 'Detect whether processes/services configured for Windows are running and allow remote connections only in such environments.',
    'add_excluding_exe': 'Add (.exe excluded)',
    'application_reason_approval_opinion_settings': 'Settings for Application Reason and Approval Opinion',
    'enter_application_reason': 'Please enter the application reason.',
    'enter_approval_opinion': 'Please enter the approval opinion.',
    'recording_storage_path_validation': 'Validate the recording storage path.',
    'storage_path_unreachable': 'Unable to access or locate the configured storage path.',
    'storage_access_success': 'The configured storage path is accessible.',
    'windows_antivirus_check_settings': 'Windows Antivirus Installation/Execution Check Settings',
    'antivirus_process_name': 'Antivirus Process Name<br>(.exe excluded)',
    'antivirus_process_name_excluding_exe': 'Antivirus Process Name<br>(.exe excluded)',
    'antivirus_detection_by_process': 'Detect antivirus installation and execution using Windows process names.',
    'system_policy': 'System Policy',
    'system_policy_applies_to_all': 'The system policy applies to the entire system and users.',
    'approval_process_enabled': '① Enabled: Exceptions/applications for each user can be set in the approval process.',
    'approval_process_exception_unchanged': '- Switching to enabled does not affect existing exception users in the approval process.',
    'approval_process_disabled': '② Disabled: Remote connection without the approval process for all users.',
    'ip_management_enabled': '① Enabled: Activate the Manage-Access IP Management menu, allowing block/allow by user IP.',
    'ip_management_disabled': '② Disabled: Deactivate the Manage-Access IP Management menu, no control over user IP access.',
    'connection_maintenance_policy': 'Connection Maintenance Policy',
    'forced_logout_manager': 'Forced Logout (Manager)',
    'web_app_manager_forced_logout': 'For WEB and APP manager logins, managers are forced to log out after the configured time. (Set to 0 to disable the policy)',
    'idle_auto_logout_manager': 'Idle Auto Logout (Manager)',
    'web_app_manager_idle_logout': 'For WEB and APP manager logins, managers are auto-logged out if idle for the configured time. (Set to 0 to disable the policy)',
    'forced_termination_viewer': 'Forced Termination (Viewer)',
    'remote_connection_forced_termination': 'Remote connections are forcibly terminated after the configured time. (Set to 0 to disable the policy)',
    'idle_auto_termination_viewer': 'Idle Auto Termination (Viewer)',
    'remote_connection_idle_termination': 'Remote connections are auto-terminated if idle for the configured time. (Set to 0 to disable the policy)',
    'statistics_history_cycle_settings': 'Statistics History Cycle Settings',
    'remote_policy': 'Remote Policy',
    'remote_control': 'Remote Control',
    'block_allow': 'Block/Allow',
    'remote_control_restriction': 'Restrict or allow remote control functionality for users.',
    'file_transfer_restriction': 'Restrict or allow file transfer functionality for users.',
    'screen_capture_recording_restriction': 'Restrict or allow screen capture and recording functionality.',
    'keyboard_mouse_lock': 'Keyboard and Mouse Lock',
    'not_applied_applied': 'Not Applied/Applied',
    'keyboard_mouse_lock_settings': 'Configure whether the keyboard and mouse lock is applied during remote connection.',
    'screen_block_black_screen': 'Screen Block (Black Screen)',
    'screen_block_black_screen_settings': 'Configure whether the screen block (black screen) is applied during remote connection.',
    'screen_saver': 'Screen Saver',
    'maintain_prevent': 'Maintain/Prevent',
    'screen_saver_local_settings': 'Configure whether the screen saver settings on the remote PC are maintained or prevented.',
    'screen_power_saving': 'Screen Power Saving',
    'screen_power_saving_local_settings': 'Configure whether screen power saving settings on the remote PC are maintained or prevented.',
    'power_saving': 'Power Saving',
    'power_saving_local_settings': 'Configure whether power saving settings on the remote PC are maintained or prevented.',
    'account_security_policy': 'Account Security Policy',
    'password_complexity': 'Password Complexity',
    'user_remote_approval': 'User Remote Approval',
    'disabled_enabled': 'Disabled/Enabled',
    'remote_request_and_approval': 'Remote connection functionality after request and approval.',
    'manager_registration_approval': 'Manager Registration Approval',
    'manager_registration_with_approval': 'Requires approval before manager registration.',
    'remote_device_registration_approval': 'Remote Device Registration Approval',
    'remote_device_registration_with_approval': 'Requires approval before remote device registration.',
    'internal_network_admin_ip_management': 'Allow internal network admin IP management for policy administrators.',
    'windows_version_check': 'Windows Version Check',
    'windows_version_restriction': 'Allow remote access only for users meeting the specified Windows version.',
    'windows_auto_update_check': 'Windows Auto Update Check',
    'windows_auto_update_activation_check': 'Allow remote access only after verifying Windows auto-update is enabled.',
    'windows_antivirus_installation_execution_check': 'Windows Antivirus Installation/Execution Check',
    'antivirus_installation_execution_restriction': 'Allow remote access only for users with the specified antivirus installed and running.',
    'windows_process_service_check': 'Windows Process/Service Check',
    'process_service_running_restriction': 'Allow remote access only for users running the specified processes and services.',
    'or_higher': 'or Higher',
    'manager_registration_request_history': 'Manager Registration Request History',
    'manager_registration_request_approval': 'Manager Registration Request Approval',
    'approve_manager_registration_requests': 'Do you want to approve the above manager registration request(s)?',
    'manager_integration_management': 'Manager Integration Management',
    'manager_registration_deletion_history': 'Manager Registration/Deletion History',
    'user_remote_request_approval': 'User Remote Request Approval',
    'remote_request_approval': 'Request Approval',
    'user_remote_control_history': 'Remote Control History(Self)',
    'remote_control_history': 'Control History',
    'remote_control_history_self': 'Control History (Self)',
    'user_remote_request_history': 'User Request History',
    'remote_request_history': 'Request History',
    'rejection_reason': 'Rejection Reason',
    'manager_management': 'Manager Management',
    'integration_management': 'Integration Mgmt',
    'registration_request_approval': 'Request Approval',
    'registration_request_history': 'Reg Request Hist',
    'registration_deletion_history': 'Reg/Del History',
    'windows_process_service_check_settings': 'Windows Process/Service Check Settings',
  },
  'statistics_page': {
    'development_environment': 'Development Environment',
    'connection_datetime': 'Connection Date and Time',
    'connection_environment': 'Connection Environment',
    'user_login_history': 'User Login History',
    'internal_network': 'Internal Network',
    'external_network': 'External Network',
    'login_date': 'Login Date',
    'login_time': 'Login Time',
    'remote_control_history_statistics': 'Remote Control History Statistics',
    'remote_control_connection_count': 'Remote Control Connection Count',
    'connection_count': 'Connection Count',
    'manager_remote_control_by_os': 'Manager Remote Control by OS',
  },
  'support_page': {
    'remote_access_manual': 'Remote Access Manual',
    'remote_management_manual': 'Remote Management Manual',
    'delete_notice': 'Delete Notice',
    'confirm_deletion': 'Are you sure you want to delete?',
    'author': 'Author',
    'title': 'Title',
    'content': 'Content',
    'register_notice': 'Register Notice',
    'enter_title': 'Enter a title',
  },
  'user_page': {
    'approver_management': 'Approver Management',
    'bulk_update': 'Bulk Update',
    'not_set': 'Not Set',
    'step': 'Step',
    'approval_step': 'Approval Step',
    'no_selected_items': 'No items selected.',
    're_registration_requirements': 'To re-register a deleted remote device, it must be logged in locally and go through the remote device registration approval process.',
    'no_selected_remote_device': 'No remote device selected.',
    'confirm_update_mid_manager_approval_step': 'Would you like to update the approval step settings for the middle managers listed below?',
    'policy_manager_fixed_approval_step': 'The approval step for the policy manager is fixed as \'All\' and cannot be changed.',
    'approval_step_update': 'Update Approval Step',
    'select_approval_step': 'Please select an approval step.',
    'department_members': 'Department Members',
    'registered_manager': 'Registered Manager',
    'no_selected_manager': 'No manager selected.',
    'add_department_member': 'Add Department Member',
    'select_exclude': 'Exclude Selected',
    'confirm_user_exclusion': 'Would you like to exclude the following user(s) from {departmentName}?',
    'excluded_user_temp_department': 'Excluded users will be temporarily moved to an unassigned department. Department changes can be made under user management.',
    'exclude': 'Exclude',
    'approval_process': 'Approval Process',
    'department_management_department_members': 'Department Management: Department Members',
    'post_approval_permission': 'Post Approval Permission',
    'department_head': 'Department Head',
    'bulk_apply': 'Bulk Apply',
    'bulk_retrieval': 'Bulk Retrieval',
    'select_department_head': 'Select Department Head',
    'department_member_management': 'Dept Members',
    'members': 'Members',
    'department_policy': 'Department Policy',
    'registered_remote_device': 'Registered Remote Device',
    'exclude_department_members': 'Exclude Department Members',
    'bulk_add_users': 'Bulk Add Users',
    'enter_email': 'Please enter an email.',
    'enter_valid_email': 'Please enter a valid email address (up to 40 characters).',
    'enter_password': 'Please enter a password.',
    'reenter_password': 'Please re-enter the password.',
    'position': 'Position',
    'enter_position': 'Please enter a position.',
    'enter_job_title': 'Please enter a job title.',
    'is_department_head': 'Is Department Head',
    'user_permissions': 'User Permissions',
    'self_approval_step': 'Self-Approval Step',
    'mandatory_approval_step_for_use_request': 'Mandatory Approval Step for Use Request',
    'manager_limit': 'Manager Limit',
    'remote_device_limit': 'Remote Device Limit',
    'file_transfer_permission': 'File Transfer Permission',
    'global_settings': 'Global Settings',
    'basic_user_limit': 'Basic users can only create one sub-user.',
    'dev_limit_warning': 'The maximum number of remote devices that can be registered with this account is {maxValue}. To increase this limit, please apply for additional remote devices in the payment menu.',
    'user_details': 'User Details',
    'apply_approval_process': 'Apply Approval Process',
    'view_delete': 'View/Delete',
    'manager_limit_exceeded': 'The manager limit you set is lower than the number of registered managers. Please delete some managers and try again.',
    'dev_limit_exceeded': 'You have entered a remote device usage amount ({totalDevLimit}) that exceeds the licensed limit.',
    'remote_device_limit_exceeded': 'The remote device limit you set is lower than the number of registered remote devices. Please delete some remote devices and try again.',
    'work': 'Work',
    'resignation': 'Resignation',
    'mandatory_approval_step': 'Mandatory Approval Step',
    'designated_approver': 'Designated Approver',
    'status_changed': '{name} has been changed to {status}.',
    'registration_limit': 'Registration Limit',
    'concurrent_sessions_allowed': 'Concurrent Sessions Allowed',
  },
  'access_page': {
    'unknown_error_occurred': 'An unknown error has occurred. Please try reconnecting.',
    'screen_saver_disabled': 'The screen saver is disabled, or the "Show logon screen on resume" option is turned off.',
    'start_required_process': 'Please start the required process and try reconnecting.',
    'install_and_run_antivirus': 'Please install and run the antivirus, then try reconnecting.',
    'enable_windows_auto_update': 'Please enable Windows Automatic Updates and try reconnecting.',
    'comply_with_windows_policy': 'Please comply with the Windows version requirements of the user access environment policy and try reconnecting.',
    'missing_check_program': 'The environment check program has not been downloaded.',
    'check_completed': 'Check completed successfully.',
    'user_environment_check_program': 'Please download and run the user environment check program.',
    'cannot_login_with_partner_id': 'You cannot log in with a partner ID.',
  },
  'environmentCheckError': {
    'unknown': "An unknown error occurred during the environment check.",
    'environmentCheckFailed': "Environment check failed. <br/> Please check the program error details.",
    'managerDevicePendingApproval': "The manager device is pending approval. <br/> Please update after approval.",
    'managerDeviceNotRegistered': "The manager device does not exist. <br/> Please register the manager device.",
    'environmentCheckTimeout': "The environment check timed out. <br/> Please run the environment check program.",
    'connectionError': "An unexpected error occurred during the connection."
  },
  "agent_installer_file": "Agent Installer File",
  "agent_file_description": "The agent is installed and logged in automatically using the same account.<br>Suitable for installing the agent on multiple devices.",
  "install_type": "Installation Type",
  "access_account_setting": "Access Account Setting",
  "enter_password": "Please enter your password",
  "access_permission_setting": "Access Permission Setting",
  "installer_file_expiration_date": "Expiration Date",
  "select_expiration_date": "Select Expiration Date",
  "proxy_server_setting": "Proxy Server Setting",
  "proxy_server": "Proxy Server",
  "proxy_port": "Proxy Port",
  "proxy_id": "Proxy ID",
  "proxy_password": "Proxy Password",
  "generate_installer_file": "Create Installer",
  "auto_login_install_mode": "Auto Login Install",
  "manual_login_install_mode": "Manual Login Install",
  "disabled": "Disabled",
  "manual_setting": "Manual Setting",
  "auto_setting": "Automatic Setting",
  "login_failed_invalid_credentials": "Login failed due to incorrect password.",
  "file_download_error": "An error occurred while downloading the file.",
  "agent_auto_login_agreement_text": "Terms of Service for LinkMeMine Software and its Services\n\nThe Software Product is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties.\nThe Software Product includes computer software, associated media, printed materials and “online” or electronic documentation. The Software Product also includes all executables, add-ins, user manuals, help files, and other files but not limited. The term “Use” refers the act to store, install, execute, or display the Software Product on the computer’s main memory or temporary storage RAM, CD-ROM, or other storage device.\n\n1. Access and Use of the Services.\nYour right includes the right to use the Software Product itself and the use of the accompanying services.\nRight to Use Software: You may install, use, access, run or otherwise interact with the Software Product on a single or multiple computers. Any reproduction or redistribution of any Software Product that violates this Agreement is prohibited by law and may result in severe civil and criminal penalties\nRight to Use Services: The term “Services” refers to set up the necessary conditions for remote control by installing the Software Product on a specific computer and registering it through login process.\n\n2. Copyright\nAll title and copyrights in and to the Software Product (including but not limited to any images, video, music and text) are owned by LinkMeMine and its suppliers. This Software Product is licensed, not sold. Therefore, no ownership rights or other rights regarding this Software Product are transferred to you, and the license under this Agreement shall not be construed as a sale of rights to the Software Product. However, if you comply with the terms of this License Agreement, you may make one additional copy of the Software Product for backup or archival purposes. Otherwise, you may not make additional copies of the Software Product. You may not copy the printed materials attached to this Software Product. All other rights not expressly granted under this Agreement are located at LinkMeMine Corporation.\n\n3. DESCRIPTION OF OTHER RIGHTS AND LIMITATIONS\nBy using our Services, you agree on behalf of yourself, your users and your attendees, not to (ⅰ) modify, prepare derivative works of, or reverse engineer, our Services; (ⅱ) knowingly or negligently use our Services in a way that abuses or disrupts our networks, user accounts, or the Services; (ⅲ) transmit through the Services any harassing, fraudulent of unlawful material; (ⅳ) market, or resell the Services to any third party without our permissions; (ⅴ) use the Services in violation of our policies, applicable laws, or regulations; (ⅵ) use the Services to send unauthorized advertising, or spam; (ⅶ) harvest, collect, or gather user data without their consent; or (ⅷ) transmit through the Services any material that may infringe the intellectual property or other rights of third parties.\n\n4. WARRANTY LIMIT\nWarranty: LinkMeMine Corporation warrant that the services will conform to the service descriptions under normal use for 90 days from the date of purchase. We will make reasonable effort to solve any problem or defects. If exchange is required, the product should be within 90 days of purchase. In the event of user’s negligence, mistake or inadequate use, exchange is not an option.\nLimited Warranty: You agree to the entire risk as to the use and performance of this software product. LinkMeMine Corporation and its suppliers disclaim all warranties, express or implied, to the maximum extent permitted by applicable law. LinkMeMine does not warrant that the functions in Software Product will meet your requirements or that there will be no temporary interference or error when using this Software Product. LinkMeMine is not responsible for any problems caused by changes in the operating characteristics of computer hardware and computer operation systems (OS) manufactured after the shipment of this Software Product.\nCustomer Remedies: LinkMeMine’s and its suppliers’ entire liability and your exclusive remedy shall be, at LinkMeMine’s option, either (ⅰ) replacement of the product or (ⅱ) repair or replacement of the Software Product that does not meet LinkMeMine’s Limited Warranty. It will be made by returning a copy of your receipt and the Software Product to LinkMeMine Corporation within the warranty period. Software Product purchased through the electronic medium under the “electronic distribution via electronic medium” may receive remedial action by sending the proof of purchase to LinkMeMine within the warranty period.\nNo Other Warranties: LinkMeMine Corporation does not take any responsibility for the promise made by LinkMeMine’s suppliers, distributors and other third parties using oral, written and other notice means.\nIndemnity for Damages: LinkMeMine and its suppliers are not responsible for any damages caused by the use or non-availability of the Software Product and the provision of support services or their default to the maximum extent permitted by applicable law. Any damages in connection with the foregoing shall not be construed as liability to LinkMeMine in any case (whether by tort, contract, or other cause). Even if LinkMeMine notices of the possibility of such damages, LinkMeMine shall not be liable for the above damages and shall not be liable for any claims made by third parties. You acknowledge that the license fees already reflect this risk. Under this Agreement, the liability of LinkMeMine shall not exceed the amount you paid to use the services, and in the case of support services, you shall either re-provide the service or refund the fee.\n\n5. GENERAL TERMS\nThis is a legal agreement between you (either a person or an organization) and LinkMeMine Corporation for the LinkMeMine software product identified above, which includes computer software and services we (LinkMeMine) provide to you (“Customer”). This agreement replaces any previous agreement written or spoken in any form. If you have any question concerning this agreement, please contact us (LinkMeMine) through e-mail (support@linkmemine.com), phone (070-7126-8663) or post (LinkMeMine Co., Ltd, 18F 1807, Digital Road, 288, Guro-gu, Seoul, Korea).",
  "auto_install_multiple": "Auto Install",
  "single_agent_install": "Single Install",
  "license_exceeded_notice": "License Limit Exceeded Notice",

  // MDM (Device Policy & App Management)
  "mdm_page": {
    "device_policy": "Device Policy",
    "app_management": "App Management",
    "config_name": "Configuration Name",
    "config_name_search": "Search by configuration name",
    "add_config": "Add Configuration",
    "os": "OS",
    "all_os": "All OS",
    "description": "Description",
    "actions": "Actions",
    "copy": "Copy",
    "cannot_delete": "Cannot delete",
    "no_config": "No configurations registered",
    "package_id": "Package ID",
    "package_id_search": "Search by package ID",
    "app_name": "App Name",
    "app_name_search": "Search by app name",
    "add_app": "Add App",
    "install_file": "Install File",
    "format": "Format",
    "file_placeholder": "Select install file",
    "file_browse": "Browse",
    "allowed_ext": "Only {ext} files can be uploaded",
    "invalid_ext": "Only {ext} files can be uploaded",
    "apk_auto_extract": "App name, package name and version are auto-extracted from the APK",
    "install_options": "Install options",
    "silent_enable": "Install silently",
    "silent_select_file_first": "Select the install file first",
    "installer_detected_short": "{name} detected",
    "installer_not_detected": "Installer type not recognized — silent install unavailable",
    "installer_msi": "MSI",
    "installer_nsis": "NSIS",
    "installer_inno": "Inno Setup",
    "installer_installshield": "InstallShield",
    "run_after_install": "Run after install",
    "upload": "Upload",
    "uploading": "Uploading...",
    "file_required": "Please select an install file",
    "app_name_required": "Please enter the app name",
    "app_name_help": "Auto-filled from the file name — edit if needed",
    "version_required": "Please enter the version",
    "app_uploaded": "App uploaded",
    "config": "Configure",
    "no_app": "No apps registered",
    "edit_config": "Edit Configuration",
    "view_config": "Configuration Detail",
    "os_immutable": "OS cannot be changed after creation",
    "location_track": "Location Tracking",
    "location_track_use": "Enable device location tracking",
    "info_update_interval": "Device info report interval",
    "seconds": "sec",
    "update_schedule": "App update schedule (Android only)",
    "update_schedule_help": "The time you enter is in your local timezone and is converted to UTC before saving. Avoid business hours.",
    "window_start": "Start time",
    "window_end": "End time",
    "name_required": "Please enter a configuration name",
    "interval_required": "Report interval must be at least 1 second",
    "schedule_time_required": "Please enter schedule start/end times",
    "config_created": "Configuration created",
    "config_updated": "Configuration updated",
    "config_copied": "Configuration copied",
    "config_deleted": "Configuration deleted",
    "copy_config": "Copy Configuration",
    "confirm_copy": "Copy configuration \"{name}\"? Its policies and app settings will be duplicated.",
    "delete_config": "Delete Configuration",
    "confirm_delete": "Delete configuration \"{name}\"?",
    "install_policy_title": "\"{app}\" Install Policy",
    "install_policy_help": "Set how this app is applied to each configuration.",
    "install_policy": "Install Policy",
    "all_configs": "All Configurations",
    "companywide_badge": "Company-wide",
    "state_install": "Install",
    "state_none": "Not set",
    "state_uninstall": "Uninstall",
    "install_policy_saved": "Install policy saved for each configuration",
    "delete_app": "Delete App",
    "confirm_delete_app": "Delete app \"{name}\"?",
    "app_deleted": "App deleted",
    "tab_settings": "Settings",
    "tab_applications": "Applications",
    "profile_apps_help": "Set which apps are included in this configuration and their install policy.",
    "profile_apps_saved": "App install policy saved for this configuration",
    "save_profile_first": "Save the configuration first to set up apps",
  },

}
